export class AuthError extends Error {
  constructor(message: string, public status = 0, public requestId?: string) {
    super(message);
    this.name = 'AuthError';
  }
}

// Axios config can contain credentials; never pass it to UI or telemetry.
export function authError(error: any): AuthError {
  if (error instanceof AuthError) return error;
  const status = error?.response?.status || 0;
  const data = error?.response?.data;
  let message = Array.isArray(data?.messages) ? data.messages.join('. ') : data?.message;
  if (status >= 500) message = 'Authentication service temporarily unavailable. Please try again.';
  if (status === 410)
    message = 'This authentication client is out of date. Please reload the application.';
  if (status === 429) message = 'Too many requests. Please wait before trying again.';
  if (typeof message !== 'string')
    message = 'Unable to reach the authentication service. Please try again.';
  return new AuthError(message, status, data?.request_id);
}
